import { render, staticRenderFns } from "./ReportTickets.vue?vue&type=template&id=2ab89b29&scoped=true&"
import script from "./ReportTickets.vue?vue&type=script&lang=js&"
export * from "./ReportTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab89b29",
  null
  
)

export default component.exports